import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import PopupMenuContext from './PopupMenuContext';

const PopupMenuHeader = ({ className, children }) => {
  const cn = useClassNames(
    () => ['block', 'w-full', 'flex', 'items-center', 'font-semibold', 'bg-slate-100', className],
    [className],
  );
  return (
    <div className={cn}>
      <PopupMenuContext.Consumer>{children}</PopupMenuContext.Consumer>
    </div>
  );
};

PopupMenuHeader.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default PopupMenuHeader;
